export const DEFAULT_AGENT_FEE = 25;
export const FEE_CHARGED_IN_REWARDS =
  "If this booking was made using rewards, the fee will be also charged in rewards";
